/** Cùng một nguồn mặc định cho PlanListPage (fetch) và PlanFilter (UI) — tránh fetch không có `month`. */
export const defaultPlanMonthString = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
};

export const getDefaultPlanFilters = () => ({
  keyword: "",
  branch_id: "",
  department_id: "",
  plan_category: "",
  plan_type: "",
  month: defaultPlanMonthString(),
  status: "",
});
